import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'eventName',
      type: 'select',
      label: '事件名称',
      placeholder: '请选择事件',
      filterable: true,
      clearable: true
    },
    {
      field: 'initiator',
      type: 'select',
      label: '发起人',
      placeholder: '请选择发起人',
      filterable: true,
      clearable: true
    },
    {
      field: 'handoverUserid',
      type: 'input',
      label: '交接账号',
      placeholder: '请输入交接账号'
    },
    {
      field: 'takeoverUserid',
      type: 'input',
      label: '承接账号',
      placeholder: '请输入承接账号'
    },
    {
      field: 'approvalStatus',
      type: 'select',
      label: '审批状态',
      placeholder: '请选择审批状态',
      clearable: true,
      options: [
        {title: '全部', value: ''},
        {title: '未审批', value: 0},
        {title: '审批通过', value: 1},
        {title: '审批拒绝', value: 2}
      ]
    },
    {
      field: 'transferType',
      type: 'select',
      label: '转移类型',
      clearable: true,
      options: [
        {title: '全部', value: ''},
        {title: '在职业务员客户', value: 0},
        {title: '离职未分配业务员客户', value: 1},
      ]
    },
    {
      field: 'timeSlot',
      type: 'datepicker',
      label: '发起时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
